import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { RoleResponse } from '@/types/apps/role.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface AppRoleGraphQLServiceInterface {
    getFields(): Record<string, any>;
    getEntityName(): string;
}

type AppRoleListResponse = GqlListResponse<RoleResponse>;

export class AppRoleGraphQLService
    extends BaseService
    implements AppRoleGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'appRole';
    }

    public getFields(): Record<string, any> {
        return {
            code: true,
            concurrencyStamp: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            role: true,
            id: true,
            isCustomer: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
            normalizedName: true,
        };
    }

    public index(query: string): Promise<AppRoleListResponse> {
        return this.fetchGqlList(query, this.getEntityName());
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('appRole', {
            userId: this.getQueryById(),
        });
    }
}
